import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
    cardContentWrapper: {
        height: "100%",
        cursor: "pointer",
        border: "1px solid #fff",
        transition: "border 0.4s ease-in-out",
        "&:hover, &:focus": {
            boxShadow: "2px 2px 9px 2px rgba(0,0,0,0.1)",
        },
    },
    cardLink: {
        display: 'block',
        textDecoration: 'none',
        "&:hover": {
            textDecoration: 'none',
        }
    },
    cardDisabled: {
        opacity: '.5',
        cursor: 'none',
        pointerEvents: 'none',
    },
    cardContent: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: theme.spacing(3)
    },
    iconWrapper: {
        width: 100,
        height: 100,
        textAlign: 'center',
        lineHeight: 1,
        padding: theme.spacing(3),
        backgroundColor: 'rgb(255, 245, 205)',
        borderRadius: '100%',
    },
    icon: {
        width: '100%',
    },
    title: {
        fontSize: 18,
        fontWeight: 700,
        margin: theme.spacing(4, 0, 2),
    },
    description: {
        color: 'rgb(175, 179, 187)',
        textAlign: 'center',
    },
}));

